// extracted by mini-css-extract-plugin
module.exports = {"blockFullWidthImg":"blockFullWidthImg-module--blockFullWidthImg--1HHFI"};